module.exports = __webpack_public_path__ + "img/PC_06.8559a5d9.jpg";